<div class="row">
  <div class="col-sm-9">
    <div class="booking_ht">
      <sm-title-bar pageTitle="Upcoming bookings" [showBackToDashboard]="true"></sm-title-bar>
    </div>
  </div>
  <div class="col-sm-3">
  </div>
</div>


<div class="row" *ngIf="!loader && upcomingAppointmentsData.length > 0">
  <div class="col-md-6 col-sm-6 col-12 today_booking_t" *ngFor="let data  of upcomingAppointmentsData" (click)="bookingDetails(data)">
    <mat-card >
    <div class="plan-card" >
      <!-- <button mat-icon-button [matMenuTriggerFor]="data.data_type == 1 ? menu2 : membersMenu" class="more-button"
        aria-label="More options" style="position: absolute; right: 15px; top: 10px;">
        <mat-icon>more_vert</mat-icon>
      </button> -->
      <mat-menu #menu2="matMenu">
        <!-- <button mat-menu-item (click)="confirmBooking(data)"
          *ngIf="(((data.appointment_status == 0 || data.appointment_status == 1 || data.appointment_status == 2) && (data.customer_hash && data.customer_hash != 'null')))">
          <mat-icon class="material-icons-outlined">check_circle</mat-icon>
          <span>Confirm booking</span>
        </button> -->
        <button mat-menu-item (click)="bookingDetails(data)">
          <mat-icon class="material-icons-outlined">info</mat-icon>
          <span>Booking details</span>
        </button>
        <!-- <button mat-menu-item (click)="cancelBooking(data)"
          *ngIf="(((data.appointment_status == 0 || data.appointment_status == 1 || data.appointment_status == 2 || data.appointment_status == 5)&& data.is_owner == 1))">
          <mat-icon class="material-icons-outlined">cancel</mat-icon>
          <span>Cancel booking</span>
        </button> -->
        <!-- <button mat-menu-item *ngIf="(!data.customer_hash || data.customer_hash == 'null')&& data.is_owner == 1"
          (click)="deleteBooking(data)">
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span>Delete booking</span>
        </button> -->
      </mat-menu>
      <mat-menu #membersMenu="matMenu">
        <button mat-menu-item (click)="viewDetailsForMember(data)">
          <mat-icon class="material-icons-outlined">info</mat-icon>
          <span>View details</span>
        </button>
        <button mat-menu-item [disabled]="true">
          <mat-icon class="material-icons-outlined">check_circle</mat-icon>
          <span>mark as present</span>
        </button>
        <button mat-menu-item [disabled]="true">
          <mat-icon class="material-icons-outlined">cancel</mat-icon>
          <span>mark as absent</span>
        </button>
      </mat-menu>
      <div class="today_list_booking">
        <div class="today_card_img" style="position: relative; flex-shrink: 0;">

         
          <!-- For bookings -->
          <mat-icon
          *ngIf="(!data.customer_thumb_image || data.customer_thumb_image == 'null') && data.data_type == 1"
          [class.new-booking]="(data.appointment_status == 0 ||data.appointment_status == 1 || data.appointment_status == 2) && data.data_type == 1" [class.under-process]="(data.appointment_status == 3 || data.appointment_status == 7 || data.appointment_status == 9)&& data.data_type == 1" [class.completed]="data.appointment_status == 4 && data.data_type == 1" [class.cancelled]="(data.appointment_status == 6 || data.appointment_status == 8)&& data.data_type == 1" [class.confirmed]="data.appointment_status == 5 && data.data_type == 1"


       



             class="status-icon"></mat-icon>
          <mat-icon
          *ngIf="data.customer_thumb_image && data.customer_thumb_image != 'null' && data.data_type == 1"
          [class.new-booking]="(data.appointment_status == 0 ||data.appointment_status == 1 || data.appointment_status == 2) && data.data_type == 1" [class.under-process]="(data.appointment_status == 3 || data.appointment_status == 7 || data.appointment_status == 9)&& data.data_type == 1" [class.completed]="data.appointment_status == 4 && data.data_type == 1" [class.cancelled]="(data.appointment_status == 6 || data.appointment_status == 8)&& data.data_type == 1" [class.confirmed]="data.appointment_status == 5 && data.data_type == 1"

          

             class="status-icon"></mat-icon>

          <!-- For membership -->
             
          <mat-icon
          *ngIf="(!data.customer_thumb_image || data.customer_thumb_image == 'null') && data.data_type == 2"
          [class.cancelled]="(data.appointment_status == 0 )&& data.data_type == 2"
          [class.new-booking]="(data.appointment_status == 1 && !data.session_status ) && data.data_type == 2"
          [class.under-process]="(data.appointment_status == 1 && (data.session_status ==  2 || data.session_status ==  1)) && data.data_type == 2"

          [class.completed]="(data.appointment_status == 1 && data.session_status ==  3) && data.data_type == 2"

          
       



             class="status-icon"></mat-icon>
          <mat-icon
          *ngIf="data.customer_thumb_image && data.customer_thumb_image != 'null' && data.data_type == 2"
          [class.cancelled]="(data.appointment_status == 0 )&& data.data_type == 2"
          [class.new-booking]="(data.appointment_status == 1 && !data.session_status ) && data.data_type == 2"
          [class.under-process]="(data.appointment_status == 1 && (data.session_status ==  2 || data.session_status ==  1)) && data.data_type == 2"
          [class.completed]="(data.appointment_status == 1 && data.session_status ==  3) && data.data_type == 2"

          

             class="status-icon"></mat-icon>


          <div class="booking-initial" *ngIf="!data.customer_thumb_image || data.customer_thumb_image == 'null'">{{data.customer_name.slice(0,1)}}</div>
          <img class="booking-initial-img img-fluid rounded-circle" [src]="data.customer_thumb_image" alt="" *ngIf="data.customer_thumb_image && data.customer_thumb_image != 'null'" onerror="this.src='../../../../assets/images/user-avatar.svg'">
          
          <!-- <img [src]="data.customer_thumb_image != null 
            && data.customer_thumb_image != 'null'
            && data.customer_thumb_image != '' ? data.customer_thumb_image : './assets/images/photo.png'" alt=""
            class="img-fluid rounded-circle"> -->
        </div>
        <div class="m-2">
          <h2 class="plan-title"> {{ data.customer_name }}</h2>
          <p class="booking-number">  <span class="bookingstar"> {{data.time}}</span> <span *ngIf="data.data_type == 1 && data.appointment_no"><span style="color: #333;">,</span> #{{data.appointment_no}} </span></p>
          <!-- <p class="plan-info">
            {{data.booking_start_time }} -  {{data.booking_end_time }}, <span class="bookingstatus" [class.new-booking]="data.appointment_status == 0 ||data.appointment_status == 1 || data.appointment_status == 2" [class.under-process]="data.appointment_status == 3 || data.appointment_status == 7 || data.appointment_status == 9" [class.completed]="data.appointment_status == 4" [class.cancelled]="data.appointment_status == 6 || data.appointment_status == 8" [class.confirmed]="data.appointment_status == 5">{{data.bookingStat}}</span>
          </p> -->
        </div>
      </div>
      
          <div class="mobiler_ad">
            <p> {{data.phone}}, {{ data.bookingType }}</p>
          </div>
      
          <p class="plan-cost" style="margin-bottom: 6px !important;">
            <span class="label">Assigned to: </span><span class="value">{{ data.employee_name }} </span>
          </p>
   
   
      <p class="plan-cost my-2">
        <span class="value">{{ data.business_name }}</span> 
      </p>
    
      <p class="address_ph my-2">
        {{ data.business_address | ellipsify:45 }}
      </p>
    
      <!-- <p class="booking_date">
        <span>{{ data.u_booking_date }}</span>
      </p> -->

      <p class="address_ph my-2">
        <span class="bookingstatus">{{ data.u_booking_date }}</span> 
        <span class="addign" *ngIf="data.bookingStat && data.bookingStat != '---'">, Status: </span> <span class="addign"  *ngIf="data.bookingStat && data.bookingStat != '---'">{{data.bookingStat}}</span>
      </p>

    </div>
       <div class="arrow_iocn_x">
    <mat-icon>arrow_forward</mat-icon>
  </div>
  </mat-card>
</div>
  </div>


<!-- old table code -->
<!-- <mat-card appearance="outlined" *ngIf="!loader && upcomingAppointmentsData.length > 0">
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [showImageColumn]="true" [imageTemplate]="image"
      [dataSource]="upcomingAppointmentsData" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
      [showPagination]="true" [itemsPerPage]="25">
    </sm-data-table>
  </div>
</mat-card> -->

<!-- <ng-template #menuTemplate let-rowvalue> -->
  <!-- OPTION MENUS FOR BOOKINGS -->
  <!-- <div *ngIf="rowvalue.data_type == 1">
    <button mat-menu-item (click)="confirmBooking(rowvalue)"
      *ngIf="(((rowvalue.appointment_status == 0 || rowvalue.appointment_status == 1 || rowvalue.appointment_status == 2) && (rowvalue.customer_hash && rowvalue.customer_hash != 'null')))">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span>Confirm booking</span>
    </button>
    <button mat-menu-item (click)="bookingDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>Booking details</span>
    </button>
    <button mat-menu-item (click)="cancelBooking(rowvalue)"
      *ngIf="(((rowvalue.appointment_status == 0 || rowvalue.appointment_status == 1 || rowvalue.appointment_status == 2 || rowvalue.appointment_status == 5)&& rowvalue.is_owner == 1))">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
      <span>Cancel booking</span>
    </button>
    <button mat-menu-item *ngIf="(!rowvalue.customer_hash || rowvalue.customer_hash == 'null')&& rowvalue.is_owner == 1"
      (click)="deleteBooking(rowvalue)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Delete booking</span>
    </button>
  </div> -->
  <!-- OPTION MENUS FOR QUERIES -->
  <!-- <div *ngIf="rowvalue.data_type == 2">
    <button mat-menu-item (click)="viewDetailsForMember(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
    </button>
    <button mat-menu-item [disabled]="true">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span>mark as present</span>
    </button>
    <button mat-menu-item [disabled]="true">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
      <span>mark as absent</span>
    </button>
  </div>
</ng-template>

<ng-template #image let-objValue>
  <img [src]="
          objValue['customer_thumb_image'] !== null && objValue['customer_thumb_image'] !== 'null' && objValue['customer_thumb_image'] !== ''
            ? objValue['customer_thumb_image']
            : './assets/images/photo.png'
        " onerror="this.src='./assets/images/photo.png'" class="img-fluid rounded-circle" />
</ng-template> -->


  <!-- placeholder section start -->
  <div class="common_placeholder" *ngIf="!loader && upcomingAppointmentsData.length == 0">
      <div class="loading_invoice" style="padding: 50px 0px; text-align: center;">
        <div class="task_addedrt">
       <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 626 626.68" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M113.926 286.375h193.75c6.902 0 12.5-5.598 12.5-12.5s-5.598-12.5-12.5-12.5h-193.75c-6.906 0-12.5 5.598-12.5 12.5s5.594 12.5 12.5 12.5zM229.922 342.625H113.926c-6.906 0-12.5 5.598-12.5 12.5s5.594 12.5 12.5 12.5h115.996c6.902 0 12.5-5.598 12.5-12.5s-5.598-12.5-12.5-12.5zm0 0" fill="#929292" opacity="1" data-original="#000000" class=""></path><path d="M446.922 314.871V98.875c-.008-34.516-27.988-62.488-62.5-62.5h-51.25V12.5c0-6.906-5.594-12.5-12.5-12.5-6.902 0-12.5 5.594-12.5 12.5v23.875h-170V12.5c0-6.906-5.594-12.5-12.5-12.5-6.902 0-12.5 5.594-12.5 12.5v23.875h-51.25c-34.512.012-62.484 27.984-62.5 62.5V437.5c.015 34.512 27.988 62.484 62.5 62.5H293.3c24.05 61.602 88.55 97.36 153.539 85.125 64.988-12.23 112.074-68.992 112.086-135.125.12-67.125-48.254-123.125-112.004-135.129zM62.05 61.375h51.25V85.25c0 6.902 5.594 12.5 12.5 12.5 6.902 0 12.5-5.598 12.5-12.5V61.375h170V85.25c0 6.902 5.594 12.5 12.5 12.5 6.902 0 12.5-5.598 12.5-12.5V61.375h51.25c20.683.059 37.437 16.813 37.5 37.5v30.25H24.55v-30.25c.015-20.707 16.797-37.484 37.5-37.5zm0 413.625c-20.688-.059-37.442-16.816-37.5-37.5V154h397.37v158.5h-.374a137.694 137.694 0 0 0-105.633 49.613A137.705 137.705 0 0 0 286.297 475zm359.496 87.5c-62.129 0-112.5-50.367-112.5-112.5s50.371-112.5 112.5-112.5c62.133 0 112.5 50.367 112.5 112.5-.094 62.094-50.406 112.406-112.5 112.5zm0 0" fill="#929292" opacity="1" data-original="#000000" class=""></path><path d="M479.422 405.125 405.176 476l-38.38-38.5c-4.862-4.867-12.753-4.867-17.62 0-4.871 4.867-4.871 12.758 0 17.625l47.12 47.125a12.29 12.29 0 0 0 8.88 3.625 12.091 12.091 0 0 0 8.62-3.504l83-79.375a12.456 12.456 0 0 0 3.849-8.73 12.457 12.457 0 0 0-3.473-8.891c-4.867-4.883-12.746-4.996-17.75-.25zm0 0" fill="#929292" opacity="1" data-original="#000000" class=""></path></g></svg>
        </div>
        <p>No upcoming appointments show</p>
    </div>
</div>